/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { H as Header, d as defineCustomElement$1 } from './header.js';
const IonHeader = Header;
const defineCustomElement = defineCustomElement$1;
export { IonHeader, defineCustomElement };